module.exports = __webpack_public_path__ + "static/media/total_denied.861f138f.svg";